module.exports = __webpack_public_path__ + "img/hoverBox6.d04ab9ec.png";